import React from 'react'

export default function About() {
  return (
    <>
    <section class="adret_sec">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="heading">
                <h2 data-aos="fade-down" data-aos-duration="2000">
                  We're more than a software company
                </h2>
                <p data-aos="fade-down" data-aos-duration="2300">
                  At Adret Software, we're your technology partner committed to
                  innovation, quality, and your success. Our experience,
                  client-centric approach, and dedication to staying at the
                  forefront of tech make us the right choice for your digital
                  transformation.
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 col-sm-6 col-6">
              <div class="content">
                <div
                  class="top_img"
                  data-aos="zoom-in"
                  data-aos-duration="2000"
                >
                  <img
                    src="assets/image/best-price.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <h5 data-aos="zoom-out" data-aos-duration="2000">
                  Reasonable and Competitive Pricing
                </h5>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-6">
              <div class="content">
                <div
                  class="top_img"
                  data-aos="zoom-in"
                  data-aos-duration="2000"
                >
                  <img
                    src="assets/image/worldwide.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <h5 data-aos="zoom-out" data-aos-duration="2000">
                  Clients across the <br /> world
                </h5>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-6">
              <div class="content">
                <div
                  class="top_img"
                  data-aos="zoom-in"
                  data-aos-duration="2000"
                >
                  <img src="assets/image/rating.png" alt="" class="img-fluid" />
                </div>
                <h5 data-aos="zoom-out" data-aos-duration="2000">
                  10+ Years Experienced Developers
                </h5>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-6">
              <div class="content">
                <div
                  class="top_img"
                  data-aos="zoom-in"
                  data-aos-duration="2000"
                >
                  <img
                    src="assets/image/delivered.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <h5 data-aos="zoom-out" data-aos-duration="2000">
                  Delivering projects and clients satisfaction.
                </h5>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
